import React, { FC, useEffect, useState } from 'react';

interface TimerProps {
    startFromTime: string;
}

export const Timer: FC<TimerProps> = (props: TimerProps) => {
    const calculateTimePassed = (): number => {
        var nowTime = Date.now();
        var parsedTicketDate = Date.parse(props.startFromTime);
        return getDifferenceInMinutes(parsedTicketDate, nowTime);
    };

    const getDifferenceInMinutes = (date1: number, date2: number) => {
        const diffInMs = Math.abs(date2 - date1);
        return Math.floor(diffInMs / (1000 * 60));
    };

    let [timePassed, setTimePassed] = useState<number>(calculateTimePassed());

    useEffect(() => {
        var timerId = setInterval(() => setTimePassed(calculateTimePassed()), 5000);

        return () => {
            clearInterval(timerId);
        };
    });

    return <span>{timePassed} min.</span>;
};
